import { createFilterOptions } from '@mui/material/Autocomplete'
import { useField } from 'formik'
import { propEq } from 'ramda'
import { useEffect } from 'react'
import { AutocompleteField, AutocompleteFieldProps } from '../../..'
import COUNTRIES from './countries.json'

const filterOptions = createFilterOptions({
  matchFrom: 'any',
  stringify: (option: { name: string; code: string }) => `${option.name} ${option.code}`,
})

const optionTest = (option: { name: string }, value: string | { name: string }) => {
  if (typeof value === 'string') {
    return value === option.name
  } else {
    return value.name === option.name
  }
}

export const CountryPickerField = ({
  name = 'country',
  ...autocompleteProps
}: AutocompleteFieldProps) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, { initialValue }, { setValue }] = useField(name)

  useEffect(() => {
    const countryOption = COUNTRIES.find(propEq('name', initialValue))
    if (countryOption) setValue(countryOption)
  }, [initialValue])

  return (
    <AutocompleteField
      name={name}
      options={COUNTRIES}
      getOptionLabel={option => (typeof option === 'string' ? option : option.name)}
      selectOnFocus
      isOptionEqualToValue={optionTest}
      filterOptions={filterOptions}
      {...autocompleteProps}
    />
  )
}
